import React from 'react';
import utils from '../../common/utils.js';
import __ from '../language.js';
import metrics from '../services/metrics.js';
import PaginationItem from './PaginationItem.js';

export default function Pagination({ data:{ widgetModel, page, setPage, getPosts, pages: totalPages } }) {
	const anchor = '#' + widgetModel.id;
	const template = widgetModel.template;
	const pagesShown = 5;
	const range = Math.floor(pagesShown / 2);
	const rangeStart = page > range ? page - range : 1;
	const prev = 1 < page ? page - 1 : false;
	const next = page < totalPages ? page + 1 : false;
	const first = page > range + 1 ? 1 : false;
	var pages = [];
	for (let i = rangeStart; i < rangeStart + pagesShown && i <= totalPages; i++) {
		pages.push(i);
	}

	const goToPage = (newPage, event, type) => {
		if (type) {
			metrics.clickTrack(event, 'cc-page-' + type, 'click');
		} else {
			metrics.clickTrack(event, 'cc-page-number', 'click');
		}
		setPage(newPage);
		getPosts();
	};

	// never show forms in static mode outside editor
	if (widgetModel.isStatic && !widgetModel.inEditor) {
		return '';
	}

	return (
		<nav aria-label="Pagination" className="nav nav-pagination d-flex justify-content-center">
			{1 < totalPages ? (
				<ul className="pagination">
					{first ? (
						<PaginationItem
							className="page-item page-item--first"
							dataPage={first}
							href={anchor}
							onClick={(e) => {
								goToPage(first, e, 'first')}
							}
							label={"dfe" === template ? <span className="cdc-fa-angles-left"></span> : __('First')}
						/>
					) : (
						''
					)}

					<PaginationItem
						className={'page-item page-item--prev' + (prev ? '' : ' disabled')}
						dataPage={prev}
						href={anchor}
						onClick={(e) => {
							prev && goToPage(prev, e, 'prev')}
						}
						label={"dfe" === template ? <span aria-label="Previous Page" className="cdc-fa-angle-left"></span> : __('Previous')}
					/>

					{pages.map((pageIndex) => (

						<PaginationItem
							key={pageIndex}
							className={`page-item page-num ${page === pageIndex ? ' active' : ''}`}
							dataPage={pageIndex}
							href={anchor}
							onClick={(e) => {
									page !== pageIndex && goToPage(pageIndex, e)
								}
							}
							label={pageIndex}
						/>
					))}

					<PaginationItem
						className={`page-item page-item--next ${next ? '' : ' disabled'} `}
						dataPage={next}
						href={anchor}
						onClick={(e) => {
								next && goToPage(next, e, 'next')
							}
						}
						label={"dfe" === template ? <span aria-label="Next Page" className="cdc-fa-angle-right"></span> : __('Next')}
					/>
				</ul>
			) : (
				''
			)}
		</nav>
	);
}
